import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { usersOnboardingService } from "../../../../../APIServices/usersOnboarding";
import { studySubjectManagementServices } from "../../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";

const AssignFormSDVReviewer = ({
  Show,
  Hide,
  Title,
  siteId,
  subjectId,
  setAssignedUser,
  assignedUser
}) => {
  const [userList, setUserList] = useState([]);
  const [reviewLoader, setReviewLoader] = useState(false);
  const [dueDate, setDueDate] = useState("");
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const getNextDate = () => {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date.toISOString().split("T")[0];
  };

  const getAssignedAppUser = async () => {
    let data = await usersOnboardingService.getAssignedAppModeUser(studyId, "edc", StudyMode, siteId)
    setUserList(data?.data || [])
  }

  const updateStudySubjectRowData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to assign form SDV reviewer!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, assign it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setReviewLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.siteId = siteId
        userData.mode = StudyMode;
        userData.subjectId = subjectId
        userData.assignedSDVUserType = true
        userData.assignedSDVUser = assignedUser
        let data = await studySubjectManagementServices.updateStudySubjectRowData(userData);
        if (data?.statusCode === 200) {
          Hide();
        }
      }
      setReviewLoader(false);
    });
  };

  useEffect(() => {
    if(siteId){
      getAssignedAppUser()
    }
  }, [siteId]);

  useEffect(() => {
    setDueDate(getNextDate())
  }, []);
  
  useEffect(() => {
    setDueDate(assignedUser?.[0]?.dueDate)
  }, [subjectId]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label>Assign User</Form.Label>
          <Form.Select
            multiple
            value={assignedUser?.map((item) => item.userId)}
            onChange={(e) => {
              const values = Array.from(
                e.target.selectedOptions,
                (option) => option.value
              );

              const updatedUsers = values.map((userId) => {
                const existingUser = assignedUser?.find(
                  (item) => item.userId === userId
                );

                return (
                  existingUser || {
                    userId,
                    dueDate,
                  }
                );
              });

              setAssignedUser(updatedUsers);
            }}
          >
            {userList?.map((item, index) => (
              <option key={index} value={item?.userId}>
                {item?.fullName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label>Due Date</Form.Label>
          <Form.Control
            type="date"
            value={dueDate}
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) => {
              const selectedDate = e.target.value;
              setDueDate(selectedDate);
              setAssignedUser((prev) =>
                prev.map((item) => ({
                  ...item,
                  dueDate: selectedDate,
                }))
              );
            }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="p-2 hstack gap-2 bg-light border-top shadow-sm justify-content-end">
        <button
          className={`updateProfile`}
          onClick={updateStudySubjectRowData}
          disabled={reviewLoader || !studyId || assignedUser?.length === 0}
          style={{ fontSize: 12 }}
        >
          {reviewLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" />
              Assigning
            </div>
          ) : (
            "Assign Reviewer"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default AssignFormSDVReviewer;
